import { Result, err, ok } from 'neverthrow';
import { UrlRankRepository } from '../Repositories/UrlRankRepository';
import {
  UrlRankError,
  UrlRankJobStatus,
  UrlRankRequest,
  UrlRankStartResult,
} from '../../Model/UrlRank';

export class UrlRankUseCase {
  constructor(private repo: UrlRankRepository) {}

  async start(request: UrlRankRequest): Promise<Result<UrlRankStartResult, UrlRankError>> {
    try {
      const validationResult = this.validateRequest(request);
      if (validationResult.isErr()) {
        return err(validationResult.error);
      }

      const response = await this.repo.startUrlRank({
        keyword: request.keyword.trim(),
        product_url: request.product_url.trim(),
        force_refresh: request.force_refresh,
      });
      return ok(response);
    } catch (error: any) {
      return err(this.toApiError(error));
    }
  }

  async getJob(jobId: string): Promise<Result<UrlRankJobStatus, UrlRankError>> {
    try {
      if (!jobId.trim()) {
        return err({
          type: 'VALIDATION_ERROR',
          message: '순위를 확인하지 못했습니다.',
        });
      }
      const response = await this.repo.getUrlRankJob(jobId.trim());
      return ok(response);
    } catch (error: any) {
      return err(this.toApiError(error));
    }
  }

  private validateRequest(request: UrlRankRequest): Result<void, UrlRankError> {
    if (!request.keyword?.trim() || !request.product_url?.trim()) {
      return err({
        type: 'VALIDATION_ERROR',
        message: '키워드와 상품 링크를 모두 입력해 주세요.',
      });
    }
    return ok(undefined);
  }

  private toApiError(_error: any): UrlRankError {
    return {
      type: 'API_ERROR',
      message: '순위를 확인하지 못했습니다.',
    };
  }
}
